import '@babel/polyfill'

import Vue from 'vue'
import moment from 'moment'
import App from './App'
import router from './router'
import store from './store/store'

import './plugins/vuetify'
import './plugins/transitions'
import './plugins/session'
import './plugins/http'
import './plugins/lodash'
import './plugins/helpers'

import './directives/input-filter'
import MSelect from './components/MSelect'
import Autocomplete from './components/Autocomplete'
import Hierarquia from './components/Hierarquia'
import HierarquiaMembro from './components/HierarquiaMembro'

moment.locale('pt-BR')

Vue.component('m-select', MSelect)
Vue.component('autocomplete', Autocomplete)
Vue.component('hierarquia', Hierarquia)
Vue.component('hierarquia-membro', HierarquiaMembro)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
